import React from 'react'
import merge from 'lodash/merge'
import get from 'lodash/get'
import componentList from './component-list'
import { getVisible, setVisible } from '../globals/visible-components'
import TrackVisibility from 'react-on-screen'

const getBoxAttribute = (apiBox) => {
  return {
    bgColor: apiBox.backgroundColor,
    bgSrc: apiBox.backgroundImage,
    top: apiBox.top,
    bottom: apiBox.bottom,
    left: apiBox.left,
    right: apiBox.right,
  }
}

const dynamicLoadedComponents = {
  'media': (component) => {
    return component.content.srcType !== 'icon'
  },
  'webinar': () => true,
}

const Mapper = ({ component, handlers, inputMap, customProps, ...rest }) => {
  if (!componentList[component.componentType]) {
    return (
      <div>
        Unknown Component => {component.componentType}
      </div>
    )
  }

  const recursive = (components) => {
    return components.map((component) => {
      // use as function instead of component
      // because as function it doesn't break the React children logic
      return Mapper({ component, handlers, inputMap, customProps, ...rest })
    })
  }

  const defaults = {
    preventChildValidation: true,
    isResponsive: true,
    boxed: true,

    id: component._id,
    key: component._id,

    box: getBoxAttribute(get(component.content, 'box', {})),
  }

  const mergedDefaults = merge(defaults, rest)
  const compProps = {
    component,
    defaults: mergedDefaults,
    recursive,
    handlers,
    inputMap,
    customProps,
  }

  const mappedComponent = componentList[component.componentType](compProps)

  const dynamicLoadedTypes = Object.keys(dynamicLoadedComponents)
  if (dynamicLoadedTypes.indexOf(component.componentType) === -1) {
    return mappedComponent
  }

  const shouldLoadDynamic = dynamicLoadedComponents[component.componentType](
    component)
  if (!shouldLoadDynamic) {
    return mappedComponent
  }

  const Comp = ({ isVisible }) => {
    if (isVisible) {
      setVisible(component._id)
    }

    return componentList[component.componentType](compProps)
  }

  if (getVisible(component._id)) {
    return mappedComponent
  }

  return (
    <TrackVisibility offset={400}
                     partialVisibility={true}
                     key={component._id}
    >
      <Comp/>
    </TrackVisibility>

  )
}

export default Mapper


